import { CollapsibleCard, Grid } from '@yes.technology/react-toolkit'
import React from 'react'
import styled from 'styled-components'

function extendBreakpointValue(a: string, b: string) {
  return ({ extendSM }: { extendSM?: boolean }) => (extendSM ? a : b)
}

export const CollapsibleContainer = styled(CollapsibleCard)<{
  backgroundColor?: string
  color?: string
  centerHeaderElement?: React.ReactElement
  embedded?: boolean
  extendSM?: boolean
}>`
  & > :first-child {
    border: 0px;

    > nav {
      border-radius: 0 !important;
      ${({ backgroundColor }) =>
        backgroundColor && `background-color: ${backgroundColor};`}
      margin-bottom: .5rem;
      padding: 0px 1rem;

      @media (max-width: ${extendBreakpointValue('991px', '768px')}) {
        min-height: 48px;
        height: auto;
        align-content: center;
      }

      @media (min-width: 1280px) {
        padding: 0px 1.5rem;
      }

      @media (min-width: 1400px) {
        padding: 0px 2rem;
      }

      @media (min-width: ${extendBreakpointValue('992px', '768px')}) {
        > div:first-child {
          width: calc(100% - 40px);
        }

        > div > div {
          ${({ centerHeaderElement }) =>
            !!centerHeaderElement && `flex-basis: 33.333%;`}
        }

        > div > div:first-child {
          flex-grow: 0;
          width: 15%;
        }

        > div > div:last-child {
          overflow: visible;
        }

        > div > div > button {
          margin: 0 -6px;
          padding: 0 8px;
        }
      }

      @media (min-width: 992px) {
        > div > div:first-child {
          flex-grow: 0;
          width: 33.333%;
          min-width: 33.333%;
        }
      }

      > div {
        @media (max-width: ${extendBreakpointValue('991px', '767px')}) {
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: auto !important;
          padding: 0.5rem 0;
        }
      }

      > div:first-child {
        @media (max-width: ${extendBreakpointValue('991px', '767px')}) {
          width: calc(100% - 16px);
        }
      }

      > div:first-child > div:first-child {
        @media (max-width: ${extendBreakpointValue('991px', '767px')}) {
          max-width: calc(100% - 16px);
        }
      }
    }

    > div {
      padding: 0px 1rem;
      margin-bottom: 0.5rem;

      @media (min-width: 1280px) {
        padding: 0px 1.5rem;
      }

      @media (min-width: 1400px) {
        padding: 0px 2rem;
      }

      ${({ embedded }) => embedded && ``}
    }
  }
`

export const ActionsContainer = styled.div`
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const StyledGrid = styled(Grid)`
  width: 100%;
  margin: 16px auto 0 auto;

  @media (min-width: 768px) {
    max-width: 1920px;
  }
`

export const CollapsibleAreaLine = styled(CollapsibleCard)<{
  backgroundColor?: string
  color?: string
  centerHeaderElement?: React.ReactElement
  embedded?: boolean
  navSticky?: boolean
}>`
  > :first-child {
    > nav {
      ${({ navSticky }) =>
        navSticky &&
        `
        position: sticky;
        top: 0;
        z-index: 1000;
      `}
      ${({ backgroundColor }) =>
        backgroundColor && `background-color: ${backgroundColor};`}

      > div * {
        ${({ color }) => color && `color: ${color};`}
      }
    }
  }
`

export const TextFadingContainer = styled.div`
  @media (max-width: 575px) {
    max-width: 100%;
  }

  @media (min-width: 768px) {
    width: 100%;
  }
`
